import { InputChip } from '@components/ui/input-chip';
import { cn } from '@lib/utils';
import { useStore } from '@tanstack/react-form';
import { useFieldContext, useFormContext } from './form';
import { FormDescription, FormErrorMessage, FormField, FormLabel } from './shared.component';

type InputChipFieldProps = {
  allowDuplicates?: boolean;
  className?: string;
  description?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  tooltip?: React.ReactNode;
};

export function InputChipField(props: InputChipFieldProps) {
  const field = useFieldContext<string[]>();
  const form = useFormContext();
  const { allowDuplicates = false, className, description, label, placeholder, required, tooltip } = props;

  const isSubmitting = useStore(form.store, (state) => state.isSubmitting);

  return (
    <FormField className={cn('w-full', className)}>
      {label && (
        <FormLabel
          htmlFor={field.name}
          required={required}
          tooltip={tooltip}
        >
          {label}
        </FormLabel>
      )}
      {description && <FormDescription>{description}</FormDescription>}
      <InputChip
        values={field.state.value || []}
        onValuesChange={field.handleChange}
        placeholder={placeholder}
        allowDuplicates={allowDuplicates}
        className="w-full"
        disabled={isSubmitting}
      />
      <FormErrorMessage />
    </FormField>
  );
}
